define('vspot-angular/services/event-service',[], function () {
    'use strict';
    return ['resources.EventRea', function (EventRea) {

        return {
            /*
             * Get an event.
             *
             * @queryParams obj {
             *
             * @paramProperty activity_id - the Activity identifier ID
             *
             * @paramProperty accesskey - the key used to determine accessibility
             * @paramProperty startdate - edate of first event to display
             # @paramProperty enddate - edate of last event to display (typically we might want a month worth of activities for a calendar view)
             # @paramProperty selected_activity - this is the activity id of the "current" activity - not necessarily the one they entered from their invitation,
             *    but one that they have been invited to. If missing, we assume it's the same as "activity_id."
             * @paramProperty include_jobs - this indicates how much job data to return
             * @paramProperty include_comments - this indicates how much of the comments data to return - if false, then we just return the latest comment for this job.
             *      otherwise, we return every comment for this job.
             * @paramProperty include_jobassignments - this indicates how much of the jobassignment data to return.
             * @paramProperty my_jobs - optional - just return the list of jobs for the current user.
             * @paramProperty swap_jobs - optional - just return the list of available jobs for swapping with current :swap_jobassignment_id.
             * @paramProperty swap_jobassignment_id - id of the jobassignment the current user wants to swap.
             *
             *  }
             * http://localhost:3000/api/events/?activity_id=137&accesskey=57ecc5a845cdcb065c643cabacf72365a209d172&startdate=2013-01-01&enddate=2013-05-05&selected_activity=137  #
             * http://localhost:3000/api/events/?activity_id=137&accesskey=57ecc5a845cdcb065c643cabacf72365a209d172&startdate=2013-01-01&enddate=2013-05-05&selected_activity=137&include_jobs=true&include_comments=true&include_jobassignments
             *
             *
             *@returns  Resource object. See /resources.js documentation for details
             */
            query: function(queryParams) {
                if( queryParams.selected_activity === undefined ) {
                    // Assume we are authenticating off the activity_id
                    queryParams.selected_activity = queryParams.activity_id;
                }
                return EventRea.query(queryParams);
            }
        };
    }];
});

